'use strict';

var MainCtrl = function ($rootScope, $scope, $http, $timeout) {

	var rightLocation = top.location.href.includes('leaselink.azurewebsites.net');
	$scope.rightLocation = rightLocation;


	$timeout(function () {
		if (rightLocation) {
			var ele = angular.element(document.querySelector('#przekierowanie'));
			ele[0].click();
		}
	}, 10000);



	$rootScope.PartnersDB = [];
	if ($scope.user !== undefined /*&& $scope.user.Role !== 'PARTNER_OPERATOR'*/) {
		$http.get('/offerbusinessdata/GetPartnersBase').then(function (d) {
			$rootScope.PartnersDB = [];

			// $rootScope.PartnersDB = _.map(d.data, function(i) {
			//     return { k: i.Key, v: i.Name, url: i.PartnerUrl };
			// });

			$rootScope.PartnersDB = d.data;

		}, function (e) { console.log(e); });
	}
};

var OfferClientDataForOperatorCtrl = function ($rootScope, $scope, $modal, $log, $location, $http, toaster) {

};


var OfferRequestCtrl = function ($rootScope, $scope, $modal, $log, $location, $http, $timeout, $window, toaster, filterFilter, SystemPanelAdminHelperSrv) {

	$scope.Partners = [];
	$scope.AllStatuses = [{
		name: 'Anulowany',
		value: -1
	}, {
		name: 'Nowy',
		value: 0
	}, {
		name: 'Wysłano link do klienta',
		value: 10
	}, {
		name: 'Otwarty przez klienta',
		value: 20
	}, {
		name: 'Uzupełniony przez klienta',
		value: 30
	}, {
		name: 'Opłata weryfikacyjna do zapłaty',
		value: 32
	}, {
		name: 'Zapłacony przez klienta',
		value: 40
	}, {
		name: 'Ponów płatność 1 PLN',
		value: 41
	}, {
		name: 'Odrzucony przez klienta',
		value: 50
	}, {
		name: 'Prośba o uzupełnienie wymaganych dokumentów finansowych (VAT-owiec)', value: 53
	}, {
		name: 'Prośba o uzupełnienie wymaganych dokumentów finansowych (nie-VAT-owiec)', value: 54
	}, {
		name: 'Wstępna decyzja kredytowa',
		value: 52
	}, {
		name: 'Prośba o uzupełnienie wymaganych dokumentów',
		value: 55
	}, {
		name: 'Do weryfikacji BO / Przekaż do Ryzyka',
		value: 60
	}, {
		name: 'Automat scoringowy - oczekiwanie na odpowiedź', value: 61
	}, {
		name: 'Automat scoringowy - odpowiedź gotowa', value: 62
	}, {
		name: 'Analiza ryzyka', value: 63
	}, {
		name: 'Umowa wstepna przygotowana',
		value: 70
	}, {
		name: 'Konieczność opłaty WOL (uzupełnienie danych)',
		value: 71
	}, {
		name: 'WOL opłacony',
		value: 72
	}, {
		name: 'Konieczność opłaty WOL (wybór płatności)',
		value: 73
	}, {
		name: 'Ponów płatność WOL',
		value: 74
	}, {
		name: 'Weryfikacja podpisu kwalifikowanego',
		value: 76
	}, {
		name: 'Akceptacja',
		value: 80
	}, {
		name: 'Akceptacja z warunkami',
		value: 90
	}, {
		name: 'Do zmiany przez operatora',
		value: 91
	}, {
		name: 'Zmiana zamówienia przez Klienta',
		value: 95
	}, {
		name: 'Odrzucenie',
		value: 100
	}, {
		name: 'Akceptacja nowych warunków',
		value: 103
	},{
		name: 'Umowa przygotowana',
		value: 105
	}, {
		name: 'Umowa zawiera niepoprawne dane',
		value: 106
	}, {
		name: 'Umowa jest poprawna',
		value: 107
	}, {
		name: 'Umowa przekazana do klienta',
		value: 110
	}, {
		name: 'Umowa u kuriera',
		value: 111
	}, {
		name: 'Umowa zaakceptowana przez klienta',
		value: 120
	}, {
		name: 'Zapłacone częściowo',
		value: 124
	}, {
		name: 'Płatność do dostawcy',
		value: 125
	}, {
		name: 'EDEN umowa potwierdzona',
		value: 127
	}, {
		name: 'Umowa odrzucona przez klienta',
		value: 130
	}, {
		name: 'Umowa potwierdzona - wyślij towar',
		value: 200
	}, {
		name: 'Towar u kuriera',
		value: 210
	}, {
		name: 'Towar odebrany',
		value: 220
	}, {
		name: 'Towar odebrany przez klienta',
		value: 310
	}, {
		name: 'Oczekiwanie na zamówienie',
		value: 398
	}, {
		name: 'Brak IBAN',
		value: 399
	}, {
		name: 'Przygotowanie wysyłki',
		value: 401
	}, {
		name: 'Przygotowanie płatności',
		value: 402
	}, {
		name: 'Wymaga uzupełnienia danych przez sklep',
		value: 500
	}, {
		name: 'Nie wymaga uzupełnienia danych przez sklep',
		value: 505
	}, {
		name: 'Podpisanie umowy oraz odbiór towaru w punkcie sprzedaży',
		value: 507
	}, {
		name: 'Umowa uzupełniona przez sklep',
		value: 510
	}, {
		name: 'Ostateczne sprawdzenie poprawności',
		value: 600
	}, {
		name: 'Cesja Zaakceptowana',
		value: 700
	}, {
		name: 'Wniosek zakończony',
		value: 701
	}, {
		name: 'Proces zakończony',
		value: 1000
	}]

	$scope.MultiselectFilter = function (item) {

		return item.value;
	}


	// pobranie partnerow
	if ($scope.user !== undefined /*&& $scope.user.Role !== 'PARTNER_OPERATOR'*/) {

		// $http.get('/api/User').then(function(d) {
		//     $scope.Users = [];
		//     $scope.Users = _.map(d.data.Result, function(i) {
		//         return { k: i.Guid, v: i.Login, url: i.PartnerURL, FN: i.FirstName, LN: i.LastName, e: i.Email, p: i.Partner };
		//     });
		// }, function(e) { console.log(e); });

		$http.get('/offerbusinessdata/getpartnersbase').then(function (d) {
			$scope.Partners = d.data;
			// $scope.Partners = _.map(d.data, function(i) {
			//     return { k: i.Key, v: i.Name, url: i.PartnerUrl };
			// });
		}, function (e) { console.log(e); });
	}


	// domyslan strona
	//$scope.currentPage = "list";
	$scope.data = {
	};
	$scope.Request = {
		SaveDataEmail: "",
		Requestors: [{}],
		RequestItems: []
	};
	$scope.NextSteps = [];
	$scope.config = {
		itemsPerPage: 10,
		maxPages: 10,
		fillLastPage: 'yes'
	};
	$scope.requests = [];
	$scope.filteredRequests = [];
	// $scope.search = {
	//     User_Name: "",
	//     CustomerExternalDocument: "",
	//     AggragatedCalulationId: "",
	//     Status: "",
	//     Customer: "",
	//     Partner: ""
	// };

	$scope.$watch('requests', function () {
		$scope.filteredRequests = $scope.requests; //filterFilter($scope.requests, $scope.filterRequest);
	}, true);
	// $scope.$watch('search', function () {
	//     $scope.filteredRequests = filterFilter($scope.requests, $scope.filterRequest);
	// }, true);


	// pobranie danych slownikowych
	$http.get('/OfferBusinessData/GetCategoryLevels').then(
		function (d) {
			$scope.categoryDic = d.data;
		},
		function (e) {
			toaster.pop('error', "Pobieranie danych", "Pobieranie danych nie przebiegło poprawnie.");
		});


	if (!$rootScope.filterBuffer) {
		$scope.filterModel = {
			OfferGuid: "",
			Client: "",
			Operator: "",
			Status: [],
			Partners: [],
			DateFrom: moment().subtract(14, 'days').toISOString(),
			Phrase: ''
		};
	} else {
		$scope.filterModel = $rootScope.filterBuffer;
	};


	var timeoutPromise;
	var delayInMs = 0;
	$scope.ResetFilters = function () {
		delayInMs = 0;
		$scope.filterModel = {
			OfferGuid: "",
			Client: "",
			Operator: "",
			Status: [],
			Partners: [],
			Phrase: ''
		};

		$rootScope.$broadcast('multiselect::reset');
	};

	$scope.RefreshFilter = function () {
		$http.get('/api/FilterPreferences/' + $scope.user.Guid).then(
			function (d) {
				$scope.user.DefaultStatuses = d.data.Result;
				//toaster.pop('success', 'Pobieranie danych zakończone pomyślnie');
			},
			function (e) {
				toaster.pop('error', 'Odświeżenie filtra nie powiodło się');
			});
	};

	$scope.SaveUserFilterPreferences = function () {

		$http.put("/api/FilterPreferences/" + $scope.user.Guid, $scope.filterModel.Status).then(function (d) {
			$scope.RefreshFilter();
			toaster.pop('success', "Filtr", "Filtr statusów zapisany");
		}, function (e) {
			console.log(e);
			toaster.pop('error', "Filtr", "Błąd zapisu");
		});
	};


	// nasłuchuje zapisu domyślnego filtru statusów z poziomu edycji użytkownika i odświeża
	$rootScope.$on('update-statuses-filter', function (event, args) {
		$scope.RefreshFilter();
	});


	$scope.enterPressedOnInput = function (keyEvent) {
		if (keyEvent.which === 13) {
			delayInMs = 0;
			$timeout.cancel(timeoutPromise);
			$scope.loading = true;
			var filterJson = JSON.stringify($scope.filterModel);
			$scope.listRequest(filterJson);
		}
	};


	$scope.$watch('filterModel', function () {
		if ($scope.currentPage === 'list') {
			$timeout.cancel(timeoutPromise); //does nothing, if timeout already done
			timeoutPromise = $timeout(function () { //Set timeout
				$scope.loading = true;
				if (typeof $scope.filterModel.Partners === "string") {
					$scope.filterModel.Partners = [$scope.filterModel.Partners];
				}
				// bufor zapamiętujący stan filtrów (żeby się nie kasowały przy przechodzeniu na sprawę lub inne zakładki i z powrotem)
				$rootScope.filterBuffer = $scope.filterModel;

				// przekazanie do serwisu
				SystemPanelAdminHelperSrv.setCurrentFilter($scope.filterModel);


				// pobranie danych
				var filterJson = JSON.stringify($rootScope.filterBuffer);
				$scope.listRequest(filterJson);


			}, delayInMs);
		}
	}, true);

	//lista zamówień
	$scope.listRequest = function (filterJson) {
		if (!$rootScope.filterBuffer) {
			if (!filterJson) {
				$scope.filterModel = {
					OfferGuid: "",
					Client: "",
					Operator: "",
					Status: $scope.user.DefaultStatuses || [],
					Partners: [],
					DateFrom: moment().subtract(14, 'days').toISOString(),
					Phrase: ''
				};

				filterJson = JSON.stringify($scope.filterModel);
			}
		} else {
			$scope.filterModel = $rootScope.filterBuffer;
			filterJson = JSON.stringify($scope.filterModel);
		};

		// przekazanie do serwisu
		SystemPanelAdminHelperSrv.setCurrentFilter($scope.filterModel);

		// wyslanie zapytania
		$http.post('/OfferRequest/list', { filterJson: filterJson }).then(
			function (d) {
				$scope.requests = d.data;
				$scope.currentPage = "list";
				$scope.loading = false;
				delayInMs = 2000;
			},
			function (e) {
				toaster.pop('error', "Pobieranie danych", "Pobieranie danych nie przebiegło poprawnie.");
			});
	};


	$scope.repinRequest = function () {
		var modalInstance = $modal.open({
			animation: true,
			templateUrl: '/WWW/partials/request/repinRequestModal.html',
			controller: 'RepinRequestModalCtrl',
			scope: $scope,
			size: 'lg',
			resolve: {}
		});
		modalInstance.result.then(
			function () { },
			function () { }
		);

	};

	$scope.changeStatus = function () {
		var modalInstance = $modal.open({
			animation: true,
			templateUrl: '/WWW/partials/request/changeRequestStatusModal.html',
			controller: 'ChangeRequestStatusModalCtrl',
			scope: $scope,
			resolve: {}
		});
		modalInstance.result.then(
			function () { },
			function () { }
		);

	};

	// filtr do zapytan
	$scope.filterRequest = function (item) {

		if ($scope.search.CustomerExternalDocument) {
			var _v0 = ($scope.search.CustomerExternalDocument || "").toLowerCase();
			var _v1 = (item.CustomerExternalDocument || "").toLowerCase();
			var _v2 = (item.OfferClientResonse_Guid || "").toLowerCase();
			if (_v1.indexOf(_v0) === -1 && _v2.indexOf(_v0) === -1) return false;
		}

		if ($scope.search.User_Name) {
			var _v0 = ($scope.search.User_Name || "").toLowerCase();
			var _v1 = (item.User_Name || "").toLowerCase();
			if (_v1.indexOf(_v0) === -1) return false;
		}

		if ($scope.search.Status) {
			var _v0 = ($scope.search.Status || "").toLowerCase();
			var _v1 = (item.Status + "" || "").toLowerCase();
			if (_v1 !== _v0) return false;
		}

		if ($scope.search.Customer) {
			var _v0 = ($scope.search.Customer || "").toLowerCase();
			var _v1 = (item.CustomerFullName + "" || "").toLowerCase();
			var _v2 = (item.CustomerIdentificationNumber + "" || "").toLowerCase();
			if (_v1.indexOf(_v0) === -1 && _v2.indexOf(_v0) === -1) return false;
		}

		if ($scope.search.Partner) {
			var _v0 = ($scope.search.Partner || "").toLowerCase();
			var _v1 = (item.Partner_Name + "" || "").toLowerCase();
			if (_v1 !== _v0) return false;
		}


		return true;
	};

	// domyslna akcja
	if ($scope.currentPage === 'list')
		$scope.listRequest();

	// nowe zamowienie
	if ($scope.currentPage === 'form') {
		$scope.Request = {
			SaveDataEmail: "",
			SaveDataPhone: "",
			TypeOfDelivery: "",
			CustomerExternalDocument: "",
			Requestors: [{}],
			RequestItems: [{
				TaxCode: "23",
				Tax: 23,
				Quantity: 1
			}]
		};
	}

	$scope.ShowNotesForOffer = function (offerId) {
		$http.get('/api/OfferNotes?offerGuid=' + offerId).then(function (d) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: '/WWW/partials/notesForOffer.html',
				controller: 'NotesForOfferCtrl',
				resolve: {
					NotesForOffer: function () {
						return d.data.Result;
					}
				}
			});

			modalInstance.result.then(
				function () {

				},
				function () { }
			);
		});
	};




	// pobranie danych
	$scope.showRequest = function (id) {
		$http.get('/OfferRequest/get/' + id).then(
			function (d) {
				$scope.Process = d.data.Process;
				$scope.data = d.data.Data;
				$scope.Documents = d.data.Documents;

				$scope.checkInBik = new Array($scope.data.Request.Requestors.length);

				// przeslanie nowych zapytan do BIK
				$scope.useProfile2 = new Array($scope.data.Request.Requestors.length);
				$scope.useProfile2Owner = new Array($scope.data.Request.RequestorOwners.length);
				$scope.useProfile2Representative = new Array($scope.data.Request.RequestorRepresentatives.length);

				$scope.SmsHistory = d.data.SmsHistory;
				$scope.MailHistory = d.data.MailHistory;

				// pobranie danej do sprawdzenia czy użytkowik powinien widzieć "osobę kontaktową"
				$scope.ifShowContactPerson = d.data.PartnerData;

				// pobranie kolejnych krokow
				$scope.getNextSteps(id);

				// pobranie wiaodmosci
				$scope.getTopics(id);

				// podglad z podziałem na role
				$scope.currentPage = "view";

				//toaster.pop('success', "Pobieranie danych", "Pobieranie danych przebiegło poprawnie.");
			},
			function (e) {
				toaster.pop('error', "Pobieranie danych", "Pobieranie danych nie przebiegło poprawnie.");
			});
	};

	$scope.$on('showRequestBroadcast', function (event, args) {
		if (args.id) $scope.showRequest(args.id);
	});

	// edycja danych do umowy
	$scope.CurrentRequestData = {};
	$scope.currentPageMode = "";
	$scope.editAgreementData = function () {
		$scope.CurrentRequestData = $scope.data.Request;
		$scope.currentPageMode = "editAgreementData";
	};

	$scope.closeAgreementData = function () {
		$http
			.get("/system/process/get-data/" + $scope.CurrentRequestData.AggragatedCalulationId)
			.then(
				function (d) {
					$scope.CurrentRequestData = d.data.Request;
					$scope.currentPageMode = "";
				},
				function (e) {
					toaster.pop('error', "Pobranie danych do umowy", "Wystąpił błąd podczas pobierania danych.");
				}
			);
	};

	$scope.saveAgreementData = function () {
		// zapisanie
		$http.post("/system/process/save-request-data-agreement", $scope.CurrentRequestData).then(function (d) {
			toaster.pop('success', "Zapisywanie danych", "Zapisywanie danych w repozytorium powiodło się");
			$scope.CurrentRequestData = d.data.Request;
			$scope.currentPageMode = ""
			$scope.showRequest($scope.Process.OfferClientResonse_Guid);

		}, function (e) {
			toaster.pop('error', "Zapisywanie danych", "Zapisywanie danych w repozytorium nie powiodło się");
		})
	};


	//Edycja danych produktu
	$scope.currentProductData = {};
	$scope.editProductData = function () {
		$scope.currentProductData = $scope.data.Request;
		$scope.currentPageMode = "editProductData";
	};
	$scope.backProductData = function () {
		$scope.currentPageMode = "";
	};
	$scope.saveProductData = function () {
		$http.post("/system/process/save-request-data-product", $scope.currentProductData).then(function (d) {
			toaster.pop('success', "Zapisywanie danych", "Zapisywanie danych w repozytorium powiodło się");
			$scope.currentProductData = d.data.Request;
			$scope.currentPageMode = "";
		}, function (e) {
			toaster.pop('error', "Zapisywanie danych", "Zapisywanie danych w repozytorium nie powiodło się");
		})
	};

	// dodanie pozycji
	$scope.addRequestItem = function () {
		var item = {
			TaxCode: "23",
			Tax: "23",
			Quantity: 1
		};
		$scope.Request.RequestItems.push(item);
	};

	// usuniecie pozycji
	$scope.deleteRequestItem = function (idx) {
		$scope.Request.RequestItems.splice(idx, 1);
	};

	// rekalkulacja
	$scope.calculate = function (item) {
		var pNet = parseFloat(item.NetPrice);
		var q = parseFloat(item.Quantity);
		var taxCode = item.TaxCode;
		var tax = (taxCode == "zw" ? 0 : parseFloat(taxCode));
		var discount = parseFloat(item.Discount || "0");

		item.NetValue = (pNet * q) * (1 - discount / 100);
		item.GrossPrice = (pNet * (1 + tax / 100));
		item.GrossValue = ((item.NetValue) * (1 + tax / 100));
		item.TaxValue = (item.GrossValue - item.NetValue);
	};

	// edycja zapytania klienta
	$scope.editResponse = function (id) {
		$http
			.get("/system/process/get-data/" + id)
			.then(
				function (d) {
					$scope.Request = d.data.Request;
					$scope.currentPage = "form";
				},
				function (e) {
					toaster.pop('error', "Pobranie oferty", "Wystąpił błąd podczas pobierania oferty.");
				}
			);
	};

	// symulowanie
	$scope.simulateRequest = function () {
		$scope.processRequest(true);
	};

	$scope.sendRequest = function (data) {
		if (confirm("Czy na pewno chcesz wysłać ofertę ?")) {
			$scope.processRequest(false, data);
		}
	};

	$scope.sendRecalculate = function (data) {
		if (confirm("Czy na pewno chcesz przeliczyć ofertę ?")) {
			$scope.processRequest(false, data, false);
		}
	};

	// wyslanie
	$scope.processRequest = function (simulate, data, sendProposal) {

		// jezelie przekazane jako parametr
		if (data)
			$scope.Request = data;

		// czy wyslac oferte
		if (typeof sendProposal === "undefined")
			sendProposal = ($scope.Request.Simulation === true);

		//pelne przeliczenie
		$scope.Request.FullRecalculation = true;
		$scope.Request.PartnerUserGuid = $scope.user.Guid;
		$scope.Request.PartnerUserName = $scope.user.LastName + ", " + $scope.user.FirstName;
		$scope.Request.PartnerName = $scope.user.Partner;
		$scope.Request.SaveInProcess = true;
		$scope.Request.Simulation = simulate;

		// wsylanie zapytania
		$http
			.post("/api/OfferForClient?SendProposal=" + sendProposal, $scope.Request)
			.then(
				function (d) {
					if (d.data.StatusCode == 200) {
						//toaster.pop('success', "Przygotowanie kalkulacji", "Przygotowanie kalkulacji przebiegło poprawnie.");
						var AggragatedCalulationId = d.data.Result.AggragatedCalulationId;
						$scope.Request.AggragatedCalulationId = AggragatedCalulationId;
					} else {
						var error = (d && d.data && d.data.Error && d.data.Error.Message) ? (" " + d.data.Error.Message + ".") : d.data.Error;
						toaster.pop('error', "Przygotowanie kalkulacji", error);
					}
				},
				function (e) {
					var error = (e && e.data && e.data.Error && e.data.Error.Message) ? (" " + e.data.Error.Message + ".") : "";
					toaster.pop('error', "Przygotowanie kalkulacji", "Przygotowanie kalkulacji nie przebiegło poprawnie." + error);
				}
			);
	};

	// otwarcie oferty
	$scope.openResponse = function (id) {
		window.open("/process/choose.offer/" + id);
	};

	// wyslanie oferty do klienta
	$scope.sendResponse = function (id) {
		if (confirm("Czy na pewno chcesz wysłać ofertę ?")) {
			$http
				.post("/system/process/send/" + id)
				.then(
					function (d) {
						toaster.pop('success', "Wysłanie oferty", "Przesłanie oferty przebiegło poprawnie.");
					},
					function (e) {
						toaster.pop('error', "Wysłanie oferty", "Wystąpił błąd podczas przesyłania oferty.");
					}
				);
		}
	};

	// dodawanie dokumentow
	$scope.$watch("Documents", function () {
		var _docs = $scope.Documents || [];
		$scope.DocumentCounter = _.where(_docs, {
			Confirmed: false
		}).length;
	});

	// dodanie dokumentu
	$scope.addDocuments = function (id) {
		var modalInstance = $modal.open({
			animation: true,
			templateUrl: 'document-upload-form.html',
			controller: 'FileUploadCtrl',
			resolve: {
				AggragatedCalulationId: function () {
					return id;
				}
			}
		});

		modalInstance.result.then(
			function (item) { },
			function () {
				// pokazanie zapytania
				$scope.showRequest(id);
			}
		);
	};

	/* KURIER UPS */

	$scope.makeShipmentOrder = function (id) {
		if (confirm("Przed zamówieniem kuriera należy upewnić się czy dane adresowe klienta są poprawne.\nPotwierdzasz poprawność danych?"))
			$http.get(
				"/api/GenerateShipmentForOffer/" + id).then(
					function (d) {
						//window.open(d.data.Link);
						toaster.pop('success', "Kurier", "Etykieta wysyłki została dodana do listy dokumentów.");
					},
					function (e) {
						toaster.pop('error', "Kurier", "Wystąpił błąd podczas zamawiania kuriera.");
					}
				);
	};

	$scope.monitorShipment = function (id) {
		$http.get(
			"/api/TrackShipmentByOffer/" + id).then(
				function (d) {
					$scope.shipmentActivity = d.data.Result;
					toaster.pop('success', "Monitor wysyłki", "Historia przesyłki pobrana poprawnie.");
				},
				function (e) {
					toaster.pop('error', "Monitor wysyłki", "Wystąpił błąd podczas pobierania historii przesyłki.");
				}
			);
	};

	$scope.voidShipment = function (id) {
		if (confirm("Potwierdzasz anulowanie przesyłki?"))
			$http.get(
				"/api/VoidShipmentByOffer/" + id).then(
					function (d) {
						$scope.shipmentActivity = d.data.Result;
						toaster.pop('success', "Anulowanie wysyłki", "Anulowanie przesyłki poprawne.");
					},
					function (e) {
						toaster.pop('error', "Anulowanie wysyłki", "Wystąpił błąd podczas anulowania przesyłki.");
					}
				);
	};

	/* KONIEC KURIER UPS */

	// weryfikacja G2I
	$scope.verifyInG2I = function (id) {
		$http.get(
			"/system/process/verify-in-g2i/" + id).then(
				function (d) {
					//window.open(d.data.Link);
					toaster.pop('success', "Raport G2I", "Wysłano rządanie wygenerowania raportów.");
				},
				function (e) {
					toaster.pop('error', "Raport G2I", "Wystąpił błąd podczas pobierania raportu G2I. Spróbuj za chwilę.");
				}
			);
	};

	// potwierdzenie dokuemntu
	$scope.confirmDocument = function (fileId) {
		var id = $scope.data.AggragatedCalulationId;
		var fileIds = [];
		fileIds.push(fileId);
		if (confirm("Czy na pewno chcesz potwierdzić zapoznanie się z dokumentem?")) {
			$http.post("/document/confirm/" + id, {
				fileIds: fileIds
			}).then(
				function (d) {
					toaster.pop('success', "Potwierdzanie dokumentu", "Dokument potwierdzono poprawnie.");
					// pokazanie zapytania
					$scope.showRequest(id);
				},
				function (e) {
					toaster.pop('error', "Potwierdzanie dokumentu", "Wystąpił błąd podczas potwierdzania dokumentu.");
				});
		}
	};

	// potwierdzenie dokuemntu
	$scope.confirmAllDocuments = function () {
		var id = $scope.data.AggragatedCalulationId;
		var fileIds = [];
		angular.forEach($scope.Documents, function (doc) {
			if (doc.Confirmed !== true) {
				fileIds.push(doc.FileId);
			}
		});
		//if (confirm("Czy na pewno chcesz potwierdzić zapoznanie się z dokumentem?")) {
		$http.post("/document/confirm/" + id, {
			fileIds: fileIds
		}).then(
			function (d) {
				toaster.pop('success', "Potwierdzanie dokumentu", "Dokument potwierdzono poprawnie.");
				// pokazanie zapytania
				$scope.showRequest(id);
			},
			function (e) {
				toaster.pop('error', "Potwierdzanie dokumentu", "Wystąpił błąd podczas potwierdzania dokumentu.");
			});
		//}
	};

	// usuwanie dokumentu
	$scope.deleteDocument = function (fileId) {
		var id = $scope.data.AggragatedCalulationId;
		if (confirm("Czy na pewno chcesz usunąć dokument?")) {
			$http.post("/document/delete/" + id, {
				fileId: fileId
			}).then(
				function (d) {
					toaster.pop('success', "Usuwanie dokumentu", "Dokument usunięto poprawnie.");
					// pokazanie zapytania
					$scope.showRequest(id);
				},
				function (e) {
					toaster.pop('error', "Usuwanie dokumentu", "Wystąpił błąd podczas usuwania dokumentu.");
				});
		}

	};

	// pokazanie dokumentu
	$scope.showDocument = function (fileId) {
		window.open("/document/show?fileId=" + fileId);
	};


	//pobranie krokow procesu
	$scope.getNextSteps = function (id) {
		$http.get('/OfferRequest/GetProcessStep/' + id).then(
			function (d) {
				$scope.NextSteps = d.data.NextSteps;
			},
			function (e) {
				toaster.pop('error', "Pobieranie danych", "Pobieranie danych nie przebiegło poprawnie.");
			});
	};

	// ustawienie statusu procesu
	$scope.setProcessStatus = function (step) {
		if (confirm("Czy na pewno chcesz zmienić status ?")) {
			var id = $scope.Process.OfferClientResonse_Guid;
			$http.post('/OfferRequest/SetProcessStep/' + id, {
				Step: step
			}).then(
				function (d) {
					if (d.data.Status == "ERROR") {
						toaster.pop('error', "Zmiana statusu", d.data.Message);
					}
					$scope.showRequest(id);
				},
				function (e) {
					toaster.pop('error', "Pobieranie danych", "Pobieranie danych nie przebiegło poprawnie.");
				});
		}
	};


	// sprawdzenie przez nip
	$scope.onRequestorIdentificationNumber1Changed = function () { };

	// pobranie topicow
	$scope.InnerCommunicationTopics = [];
	$scope.getTopics = function (id) {
		$http.get("/Message/getTopics/" + id).then(
			function (d) {
				$scope.InnerCommunicationTopics = d.data.Topics;
				$scope.UnreadMessages = d.data.UnreadMessages;
			},
			function (e) {
				toaster.pop('error', "Pobieranie tematów", "Wystąpił błąd podczas pobierania tematów.");
			}
		);
	};

	// edycja danych komunikacyjnych
	$scope.editCommunicationData = function () {
		$scope.currentPageMode = 'editCommunicationData';
	};

	// zamkniecie
	$scope.closeCommunicationData = function () {
		$scope.currentPageMode = '';
	};

	// zapisanie danych komunikacyjnych
	$scope.saveCommunicationData = function () {
		$http.post('/system/process/save-communication-data/' + $scope.data.Request.AggragatedCalulationId, {
			contactPerson: $scope.data.Request.SaveDataContactPerson,
			email: $scope.data.Request.SaveDataEmail,
			phone: $scope.data.Request.SaveDataPhone
		})
			.then(
				function (d) {
					$scope.data = d.data.Response;
					$scope.Process = d.data.Process;
					$scope.Documents = d.data.Documents;
					$scope.currentPageMode = '';
				},
				function (e) {
					toaster.pop('error', "Zapis danych", "Wystąpił błąd podczas zapisu danych.");
				});
	};


	// edycja danych koszykowych
	$scope.editBasketData = function (calculationId) {

		if (typeof calculationId === "undefined") calculationId = "";
		$http.get('/OfferBusinessData/GetCategoryLevelsForRequest' + '?calculationId=' + calculationId).then(
			function (d) {
				// zmienna przechowująca produkty partnera, na którego jest założona sprawa - pobierane przy edycji koszyka na sprawie
				$scope.categoryForRequestDic = d.data;
			},
			function (e) {
				toaster.pop('error', "Pobieranie danych", "Pobieranie danych nie przebiegło poprawnie.");
			});
		$scope.currentPageMode = 'editBasketData';
	};

	// zmień warunki
	$scope.changeConditions = function () {
		$http.get('/ChangeConditions/GetConditionsForOffer/' + $scope.data.AggragatedCalulationId + '?packageId=' + $scope.data.PackageId).then(function (d) {
			$scope.conditions = d.data;
			//console.log(d);
		});
		$scope.currentPageMode = 'changeConditions';
	};

	// aktualizacja warunkow
	$scope.updateConditions = function () {
		var _self = this;
		$scope.areYouSure(
			{
				message: 'Czy podczas przeliczania chcesz zachować bieżący pakiet kalkulacyjny ?',
				okLabel: 'Tak',
				cancelLabel: 'Nie',
				okProcess: function () { _self.processUpdateConditions(true); },
				cancelProcess: function () { _self.processUpdateConditions(false); }
			}
		).then(function (item) { }, function () { });
	}

	// przeprocesowanie akutalizacji warunkow
	$scope.processUpdateConditions = function (savePackageId) {
		$http.post('/ChangeConditions/PostConditionsForOffer/' + $scope.data.AggragatedCalulationId, $scope.conditions).then(function (d) {
			$http
				.get("/system/process/get-data/" + $scope.data.AggragatedCalulationId)
				.then(
					function (d) {
						$scope.Request = d.data.Request;

						//$scope.simulateRequest();

						//if (data)
						//    $scope.Request = data;

						//niepelne przeliczenie = uzywamy zapisanych elemento
						$scope.Request.FullRecalculation = false;
						$scope.Request.PartnerUserGuid = $scope.user.Guid;
						$scope.Request.PartnerUserName = $scope.user.LastName + ", " + $scope.user.FirstName;
						$scope.Request.PartnerName = $scope.user.Partner;
						if (savePackageId === true) {
							$scope.Request.RequestedCalculationPackageId = d.data.PackageId;
						}
						// $scope.Request.SaveInProcess = false;
						// $scope.Request.Simulation = false;

						// wsylanie zapytania
						$http
							.post("/api/OfferForClient", $scope.Request)
							.then(
								function (d) {
									if (d.data.StatusCode == 200) {
										//toaster.pop('success', "Przygotowanie kalkulacji", "Przygotowanie kalkulacji przebiegło poprawnie.");
										var AggragatedCalulationId = d.data.Result.AggragatedCalulationId;
										$scope.Request.AggragatedCalulationId = AggragatedCalulationId;
										$scope.currentPageMode = '';
										$scope.showRequest($scope.Process.OfferClientResonse_Guid);
									} else {
										var error = (d && d.data && d.data.Error && d.data.Error.Message) ? (" " + d.data.Error.Message + ".") : d.data.Error;
										toaster.pop('error', "Przygotowanie kalkulacji", error);
									}
								},
								function (e) {
									var error = (e && e.data && e.data.Error && e.data.Error.Message) ? (" " + e.data.Error.Message + ".") : "";
									toaster.pop('error', "Przygotowanie kalkulacji", "Przygotowanie kalkulacji nie przebiegło poprawnie." + error);
								}
							);
					},
					function (e) {
						toaster.pop('error', "Pobranie oferty", "Wystąpił błąd podczas pobierania oferty.");
					}
				);
			//$scope.simulateRequest();
		});
	}

	$scope.changes = {
		wasRequestsListChanged: false
	};

	// zamkniecie
	$scope.closeBasketData = function () {
		if ($scope.changes.wasRequestsListChanged) {
			if (confirm("Zmieniłeś przedmioty oferty. Czy chcesz porzucić te zmiany?")) {
				$scope.currentPageMode = '';
				$scope.changes.wasRequestsListChanged = false;
				$scope.showRequest($scope.Process.OfferClientResonse_Guid);
			}
		} else {
			$scope.currentPageMode = '';
		}
	};

	// zadawanie pytanie
	$scope.areYouSure = function (options) {


		var modalInstance = $modal.open({
			animation: true,
			templateUrl: '/WWW/partials/areYouSure.html',
			controller: ['$scope', '$modalInstance', 'options', function ($scope, $modalInstance, options) {
				$scope.options = options || {};
				$scope.message = $scope.options.message || 'Czy na pewno chcesz wykonać akcję ?';
				$scope.okLabel = $scope.options.okLabel || 'Ok';
				$scope.cancelLabel = $scope.options.cancelLabel || 'Anuluj';
				$scope.okProcess = function () {
					if (typeof $scope.options.okProcess === 'function') {
						$scope.options.okProcess();
					}
					$modalInstance.close();
				};
				$scope.cancelProcess = function () {
					if (typeof $scope.options.cancelProcess === 'function') {
						$scope.options.cancelProcess();
					}
					$modalInstance.dismiss('cancel');
				}
			}],
			resolve: {
				options: function () {
					return options;
				},
			}
		});

		return modalInstance.result;

	};


	// zapisanie danych komunikacyjnych
	$scope.saveBasketData = function () {
		// jeśli nic nie usunęliśmy i nie dodaliśmy
		if (!$scope.changes.wasRequestsListChanged)
			$http.post('/system/process/save-basket-data/' + $scope.data.Request.AggragatedCalulationId, { request: $scope.data.Request })
				.then(
					function (d) {
						$scope.data = d.data.Response;
						$scope.currentPageMode = '';
					},
					function (e) {
						toaster.pop('error', "Zapis danych", "Wystąpił błąd podczas zapisu danych.");
					});
		// jeśli usunęliśmy lub dodaliśmy przedmioty do oferty to powiadamiamy o pełnej rekalkulacji
		else if ($scope.changes.wasRequestsListChanged) {

			// pytanie o wykonanie rekalkulacji
			$scope.areYouSure(
				{
					message: 'Przemioty oferty został zmieniony. Czy chcesz zapisać zmiany i wykonać rekalkulację oferty ?',
					okLabel: 'Tak',
					cancelLabel: 'Nie'
				}
			).then(
				function (item) {
					// czy zastąpić parametry oferty
					$scope.areYouSure(
						{
							message: 'Czy zastąpić obecne parametry kalkulacji na domyślne ?',
							okLabel: 'Tak',
							cancelLabel: 'Nie',
						}
					).then(
						function (item) {
							// pełna rekalkulacja
							$scope.data.Request.FullRecalculation = true;
							$scope.processSaveOfferData();
						},
						function () {
							// częściowa rekalkulacja
							$scope.data.Request.FullRecalculation = false;
							$scope.processSaveOfferData();
						}
					);
				},
				function () {
				}
			);
		}
	};

	// przeslanie danych do zapisu
	$scope.processSaveOfferData = function () {
		$http.post('/system/process/save-offer-data/' + $scope.data.Request.AggragatedCalulationId, { request: $scope.data.Request })
			.then(
				function (d) {
					$scope.data = d.data.Response;
					$scope.currentPageMode = '';
					$scope.changes.wasRequestsListChanged = false;
				},
				function (e) {
					toaster.pop('error', "Zapis danych", "Wystąpił błąd podczas zapisu danych.");
				});
	}

	// sprawdzenie platnosci
	$scope.checkPayment = function (payment_id) {
		$http.post('/Payment/CheckPaymentConfirmation/' + $scope.data.Request.AggragatedCalulationId, { dotpayid: payment_id })
			.then(
				function (d) {
					$scope.data = d.data.Response;
				},
				function (e) {
					toaster.pop('error', "Zapis danych", "Wystąpił błąd podczas zapisu danych.");
				});
	}

	// edycja danych oferty
	$scope.packageList = [];
	$scope.editOfferData = function () {
		$scope.currentPageMode = 'editOfferData';

		// w przypadku braku wybrania to nalezy pociagnac wyliczony package
		$scope.data.Request.RequestedCalculationPackageId = $scope.data.PackageId;

		// dociagniecie danych
		$scope.onRequestedCalculationPackageIdChange();



		// pobranie slownika offert
		$http.get("/OfferBusinessData/GetCalculationPackages").then(
			function (d) {
				$scope.packageList = d.data;
			},
			function (e) {
				toaster.pop('error', "Pobieranie danych", "Wystąpił błąd podczas pobierania danych.");
			});
	};

	// zamkniecie
	$scope.closeOfferData = function () {
		$scope.currentPageMode = '';
	};

	// zapisanie danych komunikacyjnych
	$scope.saveOfferData = function () {
		$scope.data.Request.SaveInProcess = false;
		$http.post('/system/process/save-offer-data/' + $scope.data.Request.AggragatedCalulationId, { request: $scope.data.Request })
			.then(
				function (d) {
					$scope.data = d.data.Response;
					$scope.currentPageMode = '';
					$scope.showRequest($scope.Process.OfferClientResonse_Guid);
				},
				function (e) {
					toaster.pop('error', "Zapis danych", "Wystąpił błąd podczas zapisu danych.");
				});
	};

	// zmiana na liscie wbieralnej
	$scope.onRequestedCalculationPackageIdChange = function () {
		$http.post("/OfferBusinessData/GetCalculationPackageForOffer", {
			offerId: $scope.data.AggragatedCalulationId,
			packageId: $scope.data.Request.RequestedCalculationPackageId
		})
			.then(function (d) {
				$scope.data = d.data.Response;
				$scope.addons2 = d.data.ADDONS2;
				$scope.addons3 = d.data.ADDONS3;
				$scope.data.Request.RequestedCalculationPackageId = $scope.data.PackageId;
			}, function (e) {
				toaster.pop('error', "Pobieranie danych", "Wystąpił błąd podczas pobierania danych.");
			});;
	}


	// pobranie informacji z zapytania dla
	$scope.getTermsForItem = function (item) {
		var fItem = _.find($scope.data.Request.AdditionalProducts, {
			ProductId: item.ProductId
		}) || {};
		return fItem;
	}

	// event powrotu na listę zamówień (button)
	$scope.showOrderList = function () {
		$scope.currentPage = 'list';
		$rootScope.$broadcast('context-request');

	};

	// powrót na listę zamówień (zakładka)
	$scope.$on('current-page-list', function (event, args) {
		$scope.currentPage = 'list';
	});
};


/* kontroler systemowy */
var SystemCtrl = function ($scope, $rootScope, $location, $http, $modal, toaster) {

	$scope.adminModeCounter = 0;
	$scope.adminMode = false;

	$scope.enableAdminMode = function () {
		$scope.adminModeCounter++;

		if ($scope.adminModeCounter > 6) {
			$scope.adminMode = true;
		}
	};

	$scope.newRequestByPartner = function () {
		// top.window.location.href=$scope.settings.newRequestUrl;
		window.open($scope.settings.newRequestUrl);
	}

	$scope.newRequest = function () {
		$scope.currentFunction = 'newRequest';
		console.log('systemctrk');
	};


	$scope.showFunction = function (func) {
		$scope.currentFunction = func;
	};

	$scope.showPartnerFunction = function (func) {
		$scope.currentFunction = func;
	};

	// powrót na liste zamówień (button)
	$scope.$on('context-request', function (event, args) {
		$scope.showFunction('requests');
	});

	// event powrotu na liste zamowień (zakładka)
	$scope.showPage = function (func) {
		$rootScope.$broadcast('current-page-' + func);
	};

	// powrot do produktów finansowych (button)
	$scope.$on('back-to-financial-products', function (event, args) {
		$scope.showFunction('leaselinkProducts');
	});

	// event powrotu do produktów finansowych (zakładka)
	$scope.showFinancialProductsPage = function (func) {
		$rootScope.$broadcast('current-productFunc-' + func);
	};

	// powrot do partnerow
	$scope.$on('back-to-partners', function (event, args) {
		$scope.showFunction('leaselinkProducts');
	});

	// zmiana hasła przez admina
	$scope.changeUserPassword = function () {
		// item.EditMode = false;
		var modalInstance = $modal.open({
			animation: true,
			templateUrl: '/WWW/partials/modules/users/changePassword.html',
			controller: 'UserChangePasswordCtrl'
		});

		modalInstance.result.then(function () { }, function () { });

	};

};

/* haslo uzytkownika */
var UserChangePasswordCtrl = function ($scope, $modalInstance, $http, toaster) {


	$scope.item = {
		CurrentPassword: "",
		Password: "",
		PasswordConfirm: ""
	};

	// oddanie danych
	$scope.saveNewPassword = function () {

		$http.post("/system/password-reset-confirm", {
			CurrentPassword: $scope.CurrentPassword,
			Password: $scope.Password,
			PasswordConfirm: $scope.PasswordConfirm,
			ChangePasswordOnLogon: false
		}).then(function (d) {
			$modalInstance.close();
			toaster.pop('success', "Użytkownicy", "Poprawnie zmieniono hasło")
		}, function (e) {
			toaster.pop('error', "Użytkownicy", "Zmiana hasła nie powiodła się");
		});

	};

	// zamkniecie
	$scope.cancel = function () {
		$modalInstance.dismiss('cancel');
	};

}

/* minitor */
var MonitorCtrl = function ($rootScope, $scope, $location, $http, $modal, toaster) {

	$scope.isCollapsed = true;
	$scope.MonitorRecord = [];

	$scope.Refresh = function () {
		$http.get('/api/Monitor').then(
			function (d) {
				$scope.MonitorRecord = d.data.Result;
				//toaster.pop('success', 'Pobieranie danych zakończone pomyślnie');
			},
			function (e) {
				toaster.pop('error', 'Pobieranie danych nie powiodło się');
			});
	};

	$scope.Refresh();
	$scope.Test = function (item) {
		$http.get('/api/Monitor/' + item).then(
			function (d) {
				$scope.Refresh();
				toaster.pop('success', item, 'Test został wykonany');
			},
			function (e) {
				toaster.pop('error', item, 'Próba wykonania testu zakończyła sie niepowodzeniem, spróbuj jeszcze raz');
			});
	};

	//metoda dla testu wszystkich
	$scope.TestAll = function () {
		for (var i = 0; i < $scope.MonitorRecord.length; i++) {
			$scope.Test($scope.MonitorRecord[i].PartitionKey);
		}
	};

	//metoda dla testu wszystkich
	$scope.GetReport = function (timePeriod) {
		if (!timePeriod)
			window.open('/document/GetReport');
		else
			window.open('/document/GetReport?' + 'dataOd=' + encodeURIComponent(timePeriod.From) + '&dataDo=' + encodeURIComponent(timePeriod.To));
	};

	$scope.OpenReportModal = function () {
		var modalInstance = $modal.open({
			animation: true,
			scope: $scope,
			template: '<div> <div class="modal-header"> <h4>Pobieranie raportu</h4> </div> <div class="modal-body"> <h5>Pola mogą być puste, a domyślnie pobiera się do 400 pozycji</h5> <div class="row"> <div class="col-md-6 ="> <div class="form-group"> <label>Od</label> <input class="form-control" type="text" ng-date-picker="" ng-format-date="" ng-model="timePeriod.From"/> </div> </div> <div class="col-md-6"> <div class="form-group"> <label>Do</label> <input class="form-control" type="text" ng-date-picker="" ng-format-date="" ng-model="timePeriod.To"/> </div> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-default" ng-click="cancel()">Zamknij</button> <button class="btn btn-info" ng-click="GetReport(timePeriod); ok();">Pobierz</button> </div> </div>',
			controller: ['$scope', '$modalInstance', function ($scope, $modalInstance) {
				$scope.timePeriod = {
					From: "",
					To: ""
				};
				$scope.ok = function () {
					$modalInstance.close();
				};
				$scope.cancel = function () {
					$modalInstance.dismiss('cancel');
				};
			}]
		});

		modalInstance.result.then(function () { }, function () { });
	};
};

/* ryzyko */
var RyzykoCtrl = function ($rootScope, $scope, toaster, $http) {
	$scope.PermSave = function (type, idx) {
		if (confirm("Jesteś pewien?")) {
			var link = "";
			switch (type) {
				case "representative":
					link = $scope.data.Request.RequestorRepresentatives[idx].G2IRaportUrl;
					break;
				case "owner":
					link = $scope.data.Request.RequestorOwners[idx].G2IRaportUrl;
					break;
				case "requestor":
					link = $scope.data.Request.Requestors[idx].G2IReport.RaportUrl;
					break;
				default:
					return;
			};

			$http.post("/system/process/perm-save-report", { id: $scope.data.AggragatedCalulationId, fileName: link, type: type, idx: idx }).then(function (d) {
				//console.log(d.data);
				$scope.showRequest($scope.data.AggragatedCalulationId);
			});
		}
	};

	$scope.generateG2IReportFirma = function (idx) {
		var id = $scope.data.AggragatedCalulationId;
		$http.post("/system/process/verify-object-in-g2i", { id: id, type: "requestor", idx: idx, checkInBik: $scope.checkInBik[idx], useProfile2: $scope.useProfile2[idx] })
			.then(
				function (d) {
					//$scope.data.Request.Requestors[idx].G2IRaportUrl = d.data.G2IRaportUrl;
					//$scope.data.Request.Requestors[idx].G2IRaportDate = d.data.RaportDate;
					//$scope.data.Request.Requestors[idx].G2IRaportStatus = d.data.Status;
					//if (d.data.Status)
					//    toaster.pop('success', "Raport G2I", "Pobrano raport znajdujacy się pod linkiem " + d.data.G2IRaportUrl + ".");
					//else
					//    toaster.pop('error', "Raport G2I", "Błąd podczas pobierania raportu: " + d.data.ErrorText);
					$scope.showRequest(id);
				},
				function (e) {
					toaster.pop('error', "Raport G2I", "Wystąpił błąd podczas pobierania raportu G2I. Spróbuj za chwilę.");
				}
			);
	};

	$scope.generateG2IReportOsobaOwner = function (idx) {
		var id = $scope.data.AggragatedCalulationId;
		$http.post("/system/process/verify-object-in-g2i", { id: id, type: "owner", idx: idx, useProfile2: $scope.useProfile2Owner[idx] })
			.then(
				function (d) {
					//$scope.data.Request.RequestorOwners[idx].G2IRaportUrl = d.data.G2IRaportUrl;
					//$scope.data.Request.RequestorOwners[idx].G2IRaportDate = d.data.RaportDate;
					//$scope.data.Request.RequestorOwners[idx].G2IRaportStatus = d.data.Status;
					//if (d.data.Status)
					//    toaster.pop('success', "Raport G2I", "Pobrano raport znajdujacy się pod linkiem " + d.data.G2IRaportUrl + ".");
					//else
					//    toaster.pop('error', "Raport G2I", "Błąd podczas pobierania raportu: " + d.data.ErrorText);
					$scope.showRequest(id);
				},
				function (e) {
					toaster.pop('error', "Raport G2I", "Wystąpił błąd podczas pobierania raportu G2I. Spróbuj za chwilę.");
				}
			);
	};

	$scope.generateG2IReportOsobaRepresentative = function (idx) {
		var id = $scope.data.AggragatedCalulationId;
		$http.post("/system/process/verify-object-in-g2i", { id: id, type: "representative", idx: idx, useProfile2: $scope.useProfile2Representative[idx] })
			.then(
				function (d) {
					//$scope.data.Request.RequestorRepresentatives[idx].G2IRaportUrl = d.data.G2IRaportUrl;
					//$scope.data.Request.RequestorRepresentatives[idx].G2IRaportDate = d.data.RaportDate;
					//$scope.data.Request.RequestorRepresentatives[idx].G2IRaportStatus = d.data.Status;
					//if (d.data.Status)
					//    toaster.pop('success', "Raport G2I", "Pobrano raport znajdujacy się pod linkiem " + d.data.G2IRaportUrl + ".");
					//else
					//    toaster.pop('error', "Raport G2I", "Błąd podczas pobierania raportu: " + d.data.ErrorText);
					$scope.showRequest(id);
				},
				function (e) {
					toaster.pop('error', "Raport G2I", "Wystąpił błąd podczas pobierania raportu G2I. Spróbuj za chwilę.");
				}
			);
	};
};

var AgreementInfoCtrl = function ($scope, toaster, $modal, $http) {
	$scope.agreementList = [];
	$scope.list = function () {
		$http.get('/api/AgreementInfo?offerGuid=' + $scope.Process.OfferClientResonse_Guid).then(function (d) {
			//console.log(d);
			//console.log(d.data.Result);

			$scope.agreementList = d.data.Result;
			//toaster.pop('success', "Lista umów", "Pobrano listę umów dla zapytania.");
		}, function (e) {
			toaster.pop('error', "Lista umów", "Wystąpił błąd podczas pobierania listy umów dla zapytania.");
		});
	};

	$scope.addAgreement = function () {

		$scope.dataForNewAgreementInfo = {
			AggragatedCalculation_Guid: $scope.Process.OfferClientResonse_Guid,
			AgreementNumber: "",
			ProductType: "",
			AddDate: undefined,
			WhoAdded: $scope.user.LastName + ', ' + $scope.user.FirstName
		};
		var modalInstance = $modal.open({
			animation: true,
			templateUrl: '/WWW/partials/addAgreementInfoModal.html',
			controller: 'AgreementInfoModalCtrl',
			resolve: {
				dataForNewAgreementInfo: function () {
					return $scope.dataForNewAgreementInfo;
				}
			}

		});

		modalInstance.result.then(
			function (dataForNewAgreementInfo) {
				$http.post('/api/AgreementInfo/', dataForNewAgreementInfo).then(
					function (d) {
						toaster.pop('success', 'Pomyślnie dodano nową umowę');
						$scope.list();
					},
					function (e) {
						toaster.pop('error', 'Błąd podczas dodawania nowej umowy');
					});
			},
			function (e) { }
		);
	};

	$scope.editAgreementInfo = function (id) {
		$http.get('/api/AgreementInfo/' + id).then(function (d) {
			$scope.dataForNewAgreementInfo = d.data.Result;
			$scope.dataForNewAgreementInfo.AddDate = moment(d.data.Result.AddDate).toDate();

			var modalInstance = $modal.open({
				animation: true,
				templateUrl: '/WWW/partials/addAgreementInfoModal.html',
				controller: 'AgreementInfoModalCtrl',
				resolve: {
					dataForNewAgreementInfo: function () {
						return $scope.dataForNewAgreementInfo;
					}
				}

			});

			modalInstance.result.then(
				function (dataForNewAgreementInfo) {
					$http.put('/api/AgreementInfo/' + dataForNewAgreementInfo.Guid, dataForNewAgreementInfo).then(
						function (d) {
							toaster.pop('success', 'Pomyślnie zaktualizowano umowę');
							$scope.list();
						},
						function (e) {
							toaster.pop('error', 'Błąd podczas aktualizowania umowy');
						});
				},
				function (e) { }
			);
		});
	};

	$scope.deleteAgreementInfo = function (id) {
		if (confirm("Czy na pewno chcesz usunąć tę umowę?")) {
			$http.delete('/api/AgreementInfo?guid=' + id + '&offerId=' + $scope.Process.OfferClientResonse_Guid).then(function (d) {
				toaster.pop('success', 'Pomyślnie usnięto umowę');
				$scope.list();
			},
				function (e) {
					toaster.pop('error', 'Błąd podczas usuwania umowy');
				});
		}
	};

	$scope.list();
};


var RepinRequestModalCtrl = function ($rootScope, $scope, $modalInstance, $http, toaster, filterFilter) {


	$scope.confirmRepinRequest = function (calculationId, userGuid) {

		if (confirm("Czy na pewno przepiąć wniosek?")) {
			$http.put('/api/RepinRequest/' + calculationId, { userGuid: userGuid }).then(
				function (d) {
					$rootScope.$broadcast('showRequestBroadcast', { id: calculationId });
					toaster.pop('success', 'Wniosek został przepięty na innego użytkownika');
				},
				function (e) {
					toaster.pop('error', 'Przepięcie wniosku nie powiodło się.');
				});
			$modalInstance.close();
		};
	};

	$scope.cancel = function () {
		$modalInstance.dismiss('cancel');
	};


	$scope.Users = [];

	$scope.filteredUsersList = [];

	$scope.searchUsers = {
		Phrase: "",
		Partner: ""
	};

	// filtr
	$scope.filterUsersRequest = function (item) {
		if ($scope.searchUsers.Phrase) {
			var _v0 = ($scope.searchUsers.Phrase || "").toLowerCase();
			var _v1 = (item.v + "" || "").toLowerCase();
			var _v2 = (item.FN + "" || "").toLowerCase();
			var _v3 = (item.LN + "" || "").toLowerCase();
			var _v4 = (item.e + "" || "").toLowerCase();
			if (_v1.indexOf(_v0) == -1 && _v2.indexOf(_v0) == -1 && _v3.indexOf(_v0) == -1 && _v4.indexOf(_v0) == -1) return false;
		}

		if ($scope.searchUsers.Partner) {
			var _v0 = ($scope.searchUsers.Partner || "").toLowerCase();
			var _v1 = (item.p + "" || "").toLowerCase();
			if (_v1 !== _v0) return false;
		}

		return true;
	};

	// obserwowanie filtra i glownego zbioru danych
	$scope.$watch('searchUsers', function () {
		$scope.filteredUsersList = filterFilter($scope.Users, $scope.filterUsersRequest);
	}, true);

	$scope.$watch('Users', function () {
		$scope.filteredUsersList = filterFilter($scope.Users, $scope.filterUsersRequest);
	}, true);

	// pobranie uzytkownikow
	$http.get('/api/User').then(function (d) {
		$scope.Users = _.map(d.data.Result, function (i) {
			return { k: i.Guid, v: i.Login, url: i.PartnerURL, FN: i.FirstName, LN: i.LastName, e: i.Email, p: i.Partner };
		});
	}, function (e) { console.log(e); });


};

var ChangeRequestStatusModalCtrl = function ($rootScope, $scope, $modalInstance, $http, toaster) {

	$scope.changeRequestStatus = function (calculationId, statusValue) {

		if (confirm("Czy na pewno zmienić status wniosku?")) {
			$http.put('/OfferRequest/ChangeRequestStatus/' + calculationId, $scope.currentStatus).then(
				function (d) {
					$rootScope.$broadcast('showRequestBroadcast', { id: calculationId });
					toaster.pop('success', 'Status wniosku został zmieniony.');
					$modalInstance.close();
				},
				function (e) {
					toaster.pop('error', 'Zmiana statusu nie powiodła się.');
				});
		};
	};

	$scope.cancel = function () {
		$modalInstance.dismiss('cancel');
	};


	// biezace ustawienia
	$scope.currentStatus = {
		Status: $scope.Process.Status,
		Initial: $scope.data.Initial,
		Prepaid: $scope.data.Prepaid,
		ProcessTypeName: $scope.Process.ProcessTypeName
	};

};

var AgreementInfoModalCtrl = function ($scope, $modalInstance, $http, dataForNewAgreementInfo) {
	$scope.dataForNewAgreementInfo = dataForNewAgreementInfo;
	$scope.currentTab = "";

	$scope.ok = function () {
		$modalInstance.close($scope.dataForNewAgreementInfo);
	};

	$scope.cancel = function () {
		$modalInstance.dismiss('cancel');
	};

	$scope.$watch("currentTab", function () {
		if ($scope.currentTab === "agreementPeople") {
			$http.get('/Document/GetAgreementAcceptPeople').then(function (d) {
				$scope.agreementPeople = d.data.agreementUsers;
				console.log($scope.dataForNewAgreementInfo);
				if (!$scope.dataForNewAgreementInfo.AgreementAcceptPeopleGuids || $scope.dataForNewAgreementInfo.AgreementAcceptPeopleGuids.length === 0) {
					$scope.dataForNewAgreementInfo.AgreementAcceptPeopleGuids = d.data.agreementUsers
						.filter(function (value) { return value.DefaultAcceptAgreements; })
						.map(function (value) { return value.Guid; });
				}
			});
		}
	});

	$scope.addOrRemoveFromChecked = function (item) {
		if ($scope.dataForNewAgreementInfo.AgreementAcceptPeopleGuids.length < 2 && $scope.dataForNewAgreementInfo.AgreementAcceptPeopleGuids.indexOf(item) === -1) {
			$scope.dataForNewAgreementInfo.AgreementAcceptPeopleGuids.push(item);
		} else if ($scope.dataForNewAgreementInfo.AgreementAcceptPeopleGuids.indexOf(item) !== -1) {
			var idx = $scope.dataForNewAgreementInfo.AgreementAcceptPeopleGuids.indexOf(item);
			$scope.dataForNewAgreementInfo.AgreementAcceptPeopleGuids.splice(idx, 1);
		}
		console.log($scope.dataForNewAgreementInfo.AgreementAcceptPeopleGuids);
	};
};

var NoteFormCtrl = function ($scope, $modalInstance, $http, $timeout, OfferGuid, Item, PartnerName) {
	$scope.item = {
		OfferGuid: OfferGuid,
		HasReminder: false,
		ReminderHour: 0
	}

	$scope.GetCurrentUserMail = function () {
		// jak wcześniej już edytowaliśmy, to nie ma po co wczytywać pierwszego maila
		if (!$scope.item.ReminderRecipients)
			$http.get('/System/UserMail/').then(function (d) {
				$scope.item.ReminderRecipients = d.data;
			});
	};

	$scope.$watch('item.HasReminder', function (newValue, oldValue) {
		if (newValue !== oldValue && newValue) $scope.GetCurrentUserMail();
	});

	if (Item) {
		$scope.item = Item;
		if ($scope.item.ReminderDate) {
			$scope.item.ReminderDate = moment($scope.item.ReminderDate).toDate();
			$scope.item.ReminderHour = $scope.item.ReminderDate.getHours();
		};
	};

	$scope.setHours = function (date) {
		var dateMoment = moment(date).toDate();
		dateMoment.setHours($scope.item.ReminderHour);
		$scope.item.ReminderDate = moment(dateMoment);
	};

	//$scope.ReminderHour = 0;

	$scope.ok = function () {
		$modalInstance.close($scope.item);
	};

	$scope.cancel = function () {
		$modalInstance.dismiss('cancel');
	};

	$scope.hideNoteVisiblityProperty = function () {
		if (PartnerName != "LEASELINK" && PartnerName != "LEASELINK_OPEN") {
			return false;
		}
		return true;
	}

};

var NotesForOfferCtrl = function ($scope, $modalInstance, NotesForOffer) {
	$scope.NotesForOffer = NotesForOffer;

	$scope.ok = function () {
		$modalInstance.close();
	};

	$scope.cancel = function () {
		$modalInstance.dismiss('cancel');
	};

};